import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import FormInput from '../input/FormInput';

function ForceValue({ name, value, ...props }) {
    const {
        clearErrors,
        setValue,
        trigger,
        // wrap
    } = useFormContext();

    useEffect(() => {
        // calling setValue does not call onChange
        // validation methods need to manually be called
        clearErrors([name]);
        setValue(name, value);
        trigger([name]);
    }, []);

    return <FormInput name={name} {...props} />;
}

export default ForceValue;
